import { render, staticRenderFns } from "./pjothernotice.vue?vue&type=template&id=2a68ea4e&scoped=true&"
import script from "./pjothernotice.vue?vue&type=script&lang=js&"
export * from "./pjothernotice.vue?vue&type=script&lang=js&"
import style0 from "./pjothernotice.vue?vue&type=style&index=0&id=2a68ea4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a68ea4e",
  null
  
)

export default component.exports